import { Box, Typography } from '@mui/material'

interface DashboardHeaderProps {
  userName?: string | null
}

export default function DashboardHeader({ userName }: DashboardHeaderProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant='h4' component='h1'>
        Welcome {userName}
      </Typography>
    </Box>
  )
}
